/* Publish by EComposer at 2026-10-09 11:46:21*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zqxjhis8xzh"]=  window.__ectimmers["ecom-zqxjhis8xzh"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-zqxjhis8xzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zqxjhis8xzh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pjq1qjx7sl9"]=  window.__ectimmers["ecom-pjq1qjx7sl9"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-pjq1qjx7sl9"]["jlp3n5u9y"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-pjq1qjx7sl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pjq1qjx7sl9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dda7zdttqe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dda7zdttqe', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ipjjfm1lq5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ipjjfm1lq5', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1a34g8lctdb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1a34g8lctdb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wtxhrjyv9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wtxhrjyv9h', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e67df2w9u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e67df2w9u', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7a6hxczjvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7a6hxczjvf', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yytqvvuf1z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yytqvvuf1z', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ykp0g86lti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ykp0g86lti', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yeng7kbse4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yeng7kbse4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}